import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../DataComponent/DataComponent__DatePicker';
import { I18nContext } from 'utils/I18n/context';
import moment from 'moment-timezone';
import config from '../../../config';
import DropdownList from 'react-widgets/DropdownList';

const StatisticsFilter = ({ 
    startDate: propStartDate, 
    endDate: propEndDate, 
    bindActions: propBindActions, 
    groupBy: propGroupBy,
    onAction 
}) => {
    const { t } = useContext(I18nContext);
    
    const [startDate, setStartDate] = useState(propStartDate);
    const [endDate, setEndDate] = useState(propEndDate);
    const [bindActions, setBindActions] = useState(propBindActions);
    const [groupBy, setGroupBy] = useState(propGroupBy);

    // Sync with props changes
    useEffect(() => {
        setStartDate(propStartDate);
        setEndDate(propEndDate);
        setBindActions(propBindActions);
        setGroupBy(propGroupBy);
    }, [propStartDate, propEndDate, propBindActions, propGroupBy]);

    const onGroupParamChange = useCallback((value) => {
        setGroupBy(value.value);
        onAction({
            startDate,
            endDate,
            bindActions,
            groupBy: value.value
        });
    }, [startDate, endDate, bindActions, onAction]);

    const onBindActionsChange = useCallback((item) => {
        setBindActions(item.value);
        onAction({
            startDate,
            endDate,
            bindActions: item.value,
            groupBy
        });
    }, [startDate, endDate, groupBy, onAction]);

    const onDataPickerApply = useCallback((datapicker) => {
        const nextStart = datapicker.startDate;
        const nextEnd = datapicker.endDate;
        const changed = !startDate?.isSame?.(nextStart) || !endDate?.isSame?.(nextEnd);
        if (!changed) return;
        setStartDate(nextStart);
        setEndDate(nextEnd);
        onAction({
            startDate: nextStart,
            endDate: nextEnd,
            bindActions,
            groupBy
        });
    }, [startDate, endDate, bindActions, groupBy, onAction]);

    const getGroupParams = useCallback(() => {
        const params = t?.statistics?.groupParams || {};
        let listParams = [];

        Object.keys(params).forEach(function(key) {
            listParams.push({title: params[key], value: key});
        });

        return listParams;
    }, [t]);

    const staticNames = t?.reportPage || {};
    const groupParams = getGroupParams();

    return (
        <div className="statistics__top form-inline form-horizontal">
            {/* First Row - Date, Group by, Attach actions to */}
            <div className="row table-filter">
                <div className="table-filter__item">
                    <label htmlFor="statistics-date-picker">{staticNames.date}:</label>
                    <DatePicker
                        id="statistics-date-picker"
                        onApply={onDataPickerApply}
                        startDate={startDate}
                        endDate={endDate}
                        className="btn form-control reactdaypicker-block"
                    />
                </div>
                <div className="table-filter__item">
                    <label htmlFor="statistics-group-by">{staticNames.groupBy}:</label>
                    <DropdownList
                        id="statistics-group-by"
                        className="rw-dropdownlist-select"
                        filter='startsWith'
                        dataKey='value'
                        textField='title'
                        value={groupBy}
                        data={groupParams}
                        onChange={onGroupParamChange}
                    />
                </div>
                <div className="table-filter__item table-filter__item2x">
                    <label htmlFor="statistics-bind-actions">{staticNames.connectActions}:</label>
                    <DropdownList
                        id="statistics-bind-actions"
                        className="rw-dropdownlist-select"
                        dataKey='value'
                        textField='title'
                        value={bindActions}
                        data={[
                            { title: staticNames.withTime, value: 'time' },
                            { title: staticNames.withTraffic, value: 'traffic' }
                        ]}
                        onChange={onBindActionsChange}
                    />
                </div>
            </div>
        </div>
    );
};

StatisticsFilter.propTypes = {
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    bindActions: PropTypes.any,
    groupBy: PropTypes.any,
    onAction: PropTypes.func.isRequired
};

StatisticsFilter.defaultProps = {};

export default StatisticsFilter;
